import { useState } from 'react'
import { router, usePage } from '@inertiajs/react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { GraduationCap, ChevronDown, MousePointerClick, Sparkles } from 'lucide-react'

interface TutorialsIntro {
  show: boolean
}

export function TutorialsIntroDialog() {
  const page = usePage<{ tutorials_intro?: TutorialsIntro | null }>()
  const intro = page.props.tutorials_intro

  const [open, setOpen] = useState<boolean>(Boolean(intro?.show))

  // Nada a exibir se o usuário já viu o aviso.
  if (!intro?.show) return null

  const markSeen = () => {
    fetch('/tutorials/mark_intro_seen', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token':
          document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
      },
    }).catch(console.error)
  }

  const handleClose = (nextOpen: boolean) => {
    if (!nextOpen) {
      markSeen()
    }
    setOpen(nextOpen)
  }

  const goToTutorials = () => {
    markSeen()
    setOpen(false)
    router.visit('/tutorials')
  }

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="mb-1 flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary">
            <Sparkles className="h-6 w-6" />
          </div>
          <DialogTitle className="text-xl">Novidade: Tutoriais 🎉</DialogTitle>
          <DialogDescription>
            Agora o painel tem uma seção de <strong className="text-foreground">Tutoriais</strong> com
            vídeos e guias passo a passo para você aprender a usar cada parte da Bewave.
          </DialogDescription>
        </DialogHeader>

        {/* Como chegar até lá */}
        <div className="rounded-xl border bg-muted/40 p-4">
          <p className="mb-3 flex items-center gap-2 text-sm font-medium">
            <MousePointerClick className="h-4 w-4 text-primary" />
            Como acessar quando quiser
          </p>
          <p className="text-sm text-muted-foreground">
            Clique no seu <strong className="text-foreground">avatar</strong>, no canto superior
            direito, e escolha <strong className="text-foreground">Tutoriais</strong>.
          </p>

          {/* Representação visual do caminho no menu */}
          <div className="mt-3 flex items-center gap-2">
            <span className="flex items-center gap-1.5 rounded-full border bg-background px-2 py-1">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary/10 text-[10px] font-semibold text-primary">
                EU
              </span>
              <ChevronDown className="h-3.5 w-3.5 text-muted-foreground" />
            </span>
            <span className="text-muted-foreground">→</span>
            <span className="flex items-center gap-1.5 rounded-md border bg-background px-2.5 py-1.5 text-sm font-medium text-primary">
              <GraduationCap className="h-4 w-4" />
              Tutoriais
            </span>
          </div>
        </div>

        <DialogFooter className="gap-2 sm:gap-2">
          <Button variant="ghost" onClick={() => handleClose(false)}>
            Entendi
          </Button>
          <Button onClick={goToTutorials} className="gap-2">
            <GraduationCap className="h-4 w-4" />
            Ver tutoriais agora
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
